// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kk-0";
export var buttonContainer = "_kk-3";
export var cancelButton = "_kk-4";
export var headerSection = "_kk-6";
export var headerTitle = "_kk-9";
export var messageSideLeft = "_kk-1";
export var messageSideRight = "_kk-2";
export var orderNumberContainer = "_kk-7";
export var orderNumberLabel = "_kk-8";
export var submitButton = "_kk-5";